import React, {ReactNode} from 'react';

// helpers
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

// components
import {CardBorder} from '../../../../shared/components';
import {Button} from '@mui/joy';

// styles
import {
  CardNoActiveItemTop,
  CardNoActiveItemWrapper,
  IconArrowRight,
} from './CardNoActiveItem-styles';
import {TextColors, TextDefault, TitleLarge} from '../../../../shared/styles';

// types
type Props = {
  title: string;
  icon: ReactNode;
  href: string;
};

const CardNoActiveItem = ({title, icon, href}: Props) => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  return (
    <CardBorder variant="white">
      <CardNoActiveItemWrapper>
        <CardNoActiveItemTop>
          {icon}
          <TitleLarge>{title}</TitleLarge>
        </CardNoActiveItemTop>
        <Button
          variant="plain"
          endDecorator={<IconArrowRight />}
          onClick={() => navigate(href)}>
          <TextDefault bold="bold" color={TextColors.brand}>
            {t('dashboard_seeAll')}
          </TextDefault>
        </Button>
      </CardNoActiveItemWrapper>
    </CardBorder>
  );
};

export default CardNoActiveItem;
